import { CSSProperties, FC, useMemo } from 'react';
import { clsx } from 'clsx';
import styles from './InfrastructureIcon.css';

interface IInfrastructureIconProps {
  src: string;
  color?: string;
  className?: string;
}

export const InfrastructureIcon: FC<IInfrastructureIconProps> = ({ src, color, className }) => {
  const style = useMemo<CSSProperties>(() => {
    const maskImage = `url(${src})`;

    return {
      maskImage,
      WebkitMaskImage: maskImage,
      WebkitMaskRepeat: 'no-repeat',
      backgroundColor: color,
    };
  }, [color, src]);

  return <div style={style} className={clsx(styles['infrastructure-icon'], className)} />;
};
